import get from 'lodash/get';
import Catalyst from '@Services/Catalyst';
import ProfileSettings from '@Services/ProfileSettings';

import { updateDialog } from '@Containers/Dialogs/DialogsActions';
import {
  accountSetEmailReducerType,
  accountSetIsLoadingReducerType,
  accountSetUsernameReducerType,
  accountSetRestrictedWordsReducerType,
  accountSetPasswordDataReducerType,
  typeOfAccountErrorModal,
} from './AccountConstants';

import { email as emailSelector, passwordData as passwordDataSelector } from './AccountSelectors';

export function openAccountErrorModal(props) {
  return (dispatch) => {
    dispatch(
      updateDialog({
        id: typeOfAccountErrorModal,
        dialogType: typeOfAccountErrorModal,
        ...props,
      })
    );
  };
}

export function setIsLoading(isLoading) {
  return {
    type: accountSetIsLoadingReducerType,
    payload: { isLoading },
  };
}

export function setEmail(email) {
  return {
    type: accountSetEmailReducerType,
    payload: { email },
  };
}

export function setUsername(username) {
  return {
    type: accountSetUsernameReducerType,
    payload: { username },
  };
}

export function setPasswordData(passwordData) {
  return {
    type: accountSetPasswordDataReducerType,
    payload: { passwordData },
  };
}

export function setRestrictedWords(words) {
  return {
    type: accountSetRestrictedWordsReducerType,
    payload: words,
  };
}

export function resetPassword() {
  return async (dispatch) => {
    dispatch(
      setPasswordData({
        password: '',
        newPassword: '',
        confirmPassword: '',
      })
    );
  };
}

export function resetEmail() {
  return async (dispatch) => {
    const user = ProfileSettings.get();
    dispatch(setEmail(user.PROFILE.email));
  };
}

export function trackAdobeAnalyticsPasswordError(formErrors) {
  if (!formErrors) {
    return;
  }
  formErrors.forEach((error) =>
    Catalyst.trackError(
      {
        message: error,
        component: 'Edit password',
      },
      'fe-'
    )
  );
}

const emailErrorWrongMessage = 'A username with this email address already exists';
const emailErrorRightMessage = 'This email is already in use. Please use a different one.';

export function saveEmail() {
  return async (dispatch, getState) => {
    dispatch(setIsLoading(true));
    const email = emailSelector(getState());

    await ProfileSettings.changeEmail(email)
      .finally(() => dispatch(setIsLoading(false)))
      .catch((error) => {
        dispatch(resetEmail());
        const message = get(error, 'data.message');
        const errorMessage = message.indexOf(emailErrorWrongMessage) === -1 ? message : emailErrorRightMessage;
        dispatch(openAccountErrorModal({ error: { errorMessage, errorName: 'Email change error' } }));
        Logger.error(error);
      });
  };
}

export function trackAdobeAnalyticsEmailError(formErrors) {
  if (!formErrors) {
    return;
  }
  formErrors.forEach((error) =>
    Catalyst.trackError(
      {
        message: error,
        component: 'Edit email',
      },
      'fe-'
    )
  );
}

const passwordErrorWrongMessage = 'Current password incorrect';
const passwordErrorRightMessage = 'Current password is incorrect';

export function savePassword() {
  return async (dispatch, getState) => {
    dispatch(setIsLoading(true));
    const passwordData = passwordDataSelector(getState());
    const { password, newPassword } = passwordData;
    await ProfileSettings.changePassword(password, newPassword)
      .finally(() => dispatch(setIsLoading(false)))
      .catch((error) => {
        dispatch(resetPassword());
        const message = get(error, 'message');
        const errorMessage = message.indexOf(passwordErrorWrongMessage) === -1 ? message : passwordErrorRightMessage;
        dispatch(openAccountErrorModal({ error: { errorMessage, errorName: 'Password change error' } }));
        Logger.error(error);
      });
  };
}

export const init = () => {
  return async (dispatch) => {
    const user = ProfileSettings.get();
    dispatch(setEmail(user.PROFILE.email));
    dispatch(setUsername(user.PROFILE.username));
    dispatch(setRestrictedWords([user.PROFILE.firstName, user.PROFILE.lastName]));
  };
};
